export default function submitWizard(formData) {
    grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute('6LffqaUrAAAAAJGftssLQNw1Yqz8Ef4FlVNSjYre', { action: 'LOGIN' });
        async function buildDataObject(data) {
            
            data.userString = window.navigator.userAgent;
            data.pageURL = window.location.href.split('?')[0];
            data.queryString = window.location.search;
            data.mktoFormId = '1230';
            data.mktoCookie = readCookie('_mkto_trk');
            data.ipAdress = await getIPAddress().then(ip => ip);
            data.gclid = document.getElementById('gclid_wizard').value;
            return JSON.stringify(formData);
        }

        async function getIPAddress() {
            const url = "/home/GetClientIP";
            const ipFetch = await fetch(url, {
                method: 'GET',
            });
            let ipAddress = await ipFetch.text();
            return ipAddress;
        }
        function readCookie(name) {
            var cookiename = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(cookiename) == 0) return c.substring(cookiename.length, c.length);
            }
            return null;
        }

        function verifyRecaptcha(token) {
            $.getJSON("/recaptcha/validate?token=" + token,
                function (data) {
                    const score = parseFloat(data["score"]);
                    if (score > 0.7) {
                        const postData = async () => {
                            const dataToSubmit = await buildDataObject(formData).then(data => data);
                            const url = 'https://prod-18.eastus.logic.azure.com:443/workflows/fdaecea1ff8840d9b619ae0b1f28d2f3/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=-F4HzkHXIyCZs6QMssNh9EnF2T2vhUGWiem3CQjmuNM';
                            let response = await fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json;charset=utf-8',
                                },
                                body: dataToSubmit
                            });
                            let result = await response.json();
                            if (result.success) {
                                window.lintrk('track', { conversion_id: 6985714 });
                                window.dataLayer.push({
                                    'event': 'form',
                                    'formLocation': '3stepBottom'
                                })
                            }
                        }
                        postData();
                    }
                    else {
                        console.log('Recaptch is not verified');
                    }
                }
            )
        }
        verifyRecaptcha(token);
    });

}


        //function verifyRecaptcha(token) {
        //    $.getJSON("/RecaptchaV3Vverify?token=" + token,
        //        function (data) {
        //            const score = parseFloat(data["score"]);
        //            if (score > 0.5) {  
        //                const postData = async () => {
        //                    const dataToSubmit = await buildDataObject(formData).then(data => data);
        //                    const url = 'https://prod-18.eastus.logic.azure.com:443/workflows/fdaecea1ff8840d9b619ae0b1f28d2f3/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=-F4HzkHXIyCZs6QMssNh9EnF2T2vhUGWiem3CQjmuNM';
        //                    let response = await fetch(url, {
        //                        method: 'POST',
        //                        headers: {
        //                            'Content-Type': 'application/json;charset=utf-8',
        //                        },
        //                        body: dataToSubmit
        //                    });
        //                    let result = await response.json();
        //                    if (result.success) {
        //                        window.lintrk('track', { conversion_id: 6985714 });
        //                        window.mutiny.client.trackConversion({ name: 'RequestQuote-Form' });
        //                        window.dataLayer.push({
        //                            'event': 'form',
        //                            'formLocation': '3stepBottom'
        //                        }) 
        //                    }
        //                }
        //                postData();
        //            }
        //            else {
        //                console.log('Recaptch is not verified');
        //            }
        //        }
        //    )
        //}
